import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {share} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {PolicyDocumentsRegionWorldData} from '../../../../shared/types/nso-data-portal/dashboard-data';
import {RegionInformationRestService} from '../../../../shared/services/nso-data-portal/rest-services/region-information-rest.service';
import {SearchEntityLevels} from '../../../../shared/types/nso-data-portal/search-entity-levels';
import {WorldInformationRestService} from '../../../../shared/services/nso-data-portal/rest-services/world-information-rest.service';

@Component({
  selector: 'wsd-policy-document-detail-region-world',
  templateUrl: './policy-document-detail-region-world.component.html',
  styleUrls: ['./policy-document-detail-region-world.component.css']
})
export class PolicyDocumentDetailRegionWorldComponent implements OnChanges {

  @Input()
  entityId: number;

  @Input()
  entityLevel: SearchEntityLevels;

  documents$: Observable<PolicyDocumentsRegionWorldData[]>;

  constructor(private policyRestRegionService: RegionInformationRestService,
              private policyRestWorldService: WorldInformationRestService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.entityLevel === SearchEntityLevels.REGION) {
      this.documents$ = this.policyRestRegionService.getPolicyDocuments(this.entityId).pipe(share());
    } else {
      this.documents$ = this.policyRestWorldService.getPolicyDocuments().pipe(share());
    }
  }


}
